module.exports = __webpack_public_path__ + "static/media/Headshot.d05a68aa.png";